/**
 * The backend builds the Stytch start URL and answers with a redirect, so the
 * browser has to navigate there rather than fetch it.
 */
export const backendSsoStartUrl = (connectionId: string) => {
  const url = new URL('/api/auth/sso/start', import.meta.env.VITE_API_ORIGIN)
  url.searchParams.set('connection_id', connectionId)
  return url.toString()
}
